<template>
  <div class="dk-login-page">

    <!-- Loading overlay premium -->
    <transition name="dk-fade">
      <div v-if="isLoading" class="dk-loading-overlay">
        <div class="dk-glow-center"></div>
        <div class="dk-loading-content">
          <div class="dk-logo-pulse">
            <span class="dk-play-icon">▶</span>
          </div>
          <div class="dk-brand-name">VSL<span class="dk-gold">Booster</span></div>
          <div class="dk-loading-msg">{{ loadingSteps[loadingStep].msg }}</div>
          <div class="dk-progress-wrap">
            <div class="dk-progress-track">
              <div class="dk-progress-bar" :style="{ width: loadingSteps[loadingStep].pct + '%' }"></div>
            </div>
            <div class="dk-progress-row">
              <span class="dk-progress-label">Aguarde</span>
              <span class="dk-progress-pct">{{ loadingSteps[loadingStep].pct }}%</span>
            </div>
          </div>
          <div class="dk-dots">
            <div v-for="(s, i) in loadingSteps" :key="i" class="dk-dot" :class="{ active: i === loadingStep, done: i < loadingStep }"></div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Glows decorativos -->
    <div class="dk-glow-tr"></div>
    <div class="dk-glow-bl"></div>

    <!-- Navbar -->
    <nav class="dk-nav">
      <router-link to="/" class="dk-logo" style="text-decoration:none">
        <img :src="require('@/assets/images/logo/vslbooster-logo-dark.svg')" alt="VSLBooster" style="height:40px;width:auto;object-fit:contain" />
      </router-link>
      <div class="dk-nav-right">
        <span class="dk-nav-hint">Ainda não tem conta?</span>
        <a href="https://pay.kiwify.com.br/tc9OIFy" target="_blank" class="dk-nav-cta-link">Criar minha conta →</a>
      </div>
    </nav>

    <!-- Conteúdo -->
    <div class="dk-content">

      <!-- Esquerdo: copy + stats -->
      <div class="dk-left">
        <span class="dk-badge">⚡ Plataforma #1 em Video Sales Letters</span>
        <h1 class="dk-headline">
          Descubra por que<br>seus leads abandonam<br><span class="dk-gold">e converta 3x mais.</span>
        </h1>
        <p class="dk-subtext">
          Veja o segundo exato em que seu lead para de assistir. Otimize cada frame, cada CTA, cada palavra. Com dados reais, não com achismo.
        </p>

        <div class="dk-stats-grid">
          <div class="dk-stat-card">
            <div class="dk-stat-val" style="color: #F5B935">3x</div>
            <div class="dk-stat-label">Mais conversoes</div>
          </div>
          <div class="dk-stat-card">
            <div class="dk-stat-val" style="color: #18d9ad">+47%</div>
            <div class="dk-stat-label">Retenção de video</div>
          </div>
          <div class="dk-stat-card">
            <div class="dk-stat-val" style="color: #E86A10">3.400+</div>
            <div class="dk-stat-label">Videos ativos</div>
          </div>
          <div class="dk-stat-card">
            <div class="dk-stat-val" style="color: #318feb">98%</div>
            <div class="dk-stat-label">Satisfacao</div>
          </div>
        </div>

        <div class="dk-social-proof">
          <div class="dk-avatars">
            <div class="dk-avatar" style="background:#2a6a7f">E</div>
            <div class="dk-avatar" style="background:#7a4a8f">C</div>
            <div class="dk-avatar" style="background:#2a7f5a">M</div>
            <div class="dk-avatar" style="background:#7f4a2a">R</div>
          </div>
          <span class="dk-proof-text">+3.400 vídeos gerando resultados agora</span>
        </div>
      </div>

      <!-- Direito: card glass com formulário -->
      <div class="dk-card">
        <div class="dk-card-header">
          <h2 class="dk-card-title">Bem-vindo de volta</h2>
          <p class="dk-card-sub">
            Não tem conta?
            <a href="https://pay.kiwify.com.br/tc9OIFy" target="_blank" class="dk-link-gold">Criar minha conta →</a>
          </p>
        </div>

        <!-- Erro -->
        <div v-if="errorMsg" class="dk-error-box">
          ⚠ {{ errorMsg }}
        </div>

        <validation-observer ref="loginValidation" #default="{ invalid }">
          <b-form class="dk-form" @submit.prevent="validationForm">

            <!-- E-mail -->
            <div class="dk-field-wrap">
              <label class="dk-label">E-mail</label>
              <div class="dk-input-wrap">
                <svg class="dk-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <input
                    id="email"
                    v-model="userEmail"
                    type="email"
                    class="dk-input"
                    :class="{ 'dk-input-error': errors.length > 0, 'dk-input-filled': userEmail }"
                    placeholder="seu@email.com"
                    autofocus
                  />
                  <small v-if="errors[0]" class="dk-field-error">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>

            <!-- Senha -->
            <div class="dk-field-wrap">
              <div class="dk-label-row">
                <label class="dk-label">Senha</label>
                <a href="#" class="dk-link-forgot" @click.prevent="Password()">Esqueci a senha</a>
              </div>
              <div class="dk-input-wrap">
                <svg class="dk-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="dk-input"
                    :class="{ 'dk-input-error': errors.length > 0, 'dk-input-filled': password }"
                    placeholder="••••••••"
                    style="padding-right: 48px"
                  />
                  <small v-if="errors[0]" class="dk-field-error">{{ errors[0] }}</small>
                </validation-provider>
                <button type="button" class="dk-eye-btn" @click="togglePasswordVisibility">
                  <feather-icon :icon="passwordToggleIcon" size="16" />
                </button>
              </div>
            </div>

            <!-- Lembrar -->
            <div class="dk-remember-row">
              <div class="dk-checkbox" :class="{ checked: lembrar }" @click="lembrar = !lembrar">
                <span v-if="lembrar">✓</span>
              </div>
              <span class="dk-remember-label" @click="lembrar = !lembrar">Manter conectado por 30 dias</span>
            </div>

            <!-- CTA -->
            <button type="submit" class="dk-btn-primary" :disabled="invalid || isLoading">
              {{ isLoading ? 'Entrando...' : 'Entrar no painel →' }}
            </button>
          </b-form>
        </validation-observer>

        <!-- Divisor -->
        <div class="dk-divider">
          <div class="dk-divider-line"></div>
          <span class="dk-divider-text">ou continue com</span>
          <div class="dk-divider-line"></div>
        </div>

        <p class="dk-terms">
          Ao entrar, você concorda com os
          <a href="#" class="dk-terms-link">Termos de Uso</a> e
          <a href="#" class="dk-terms-link">Política de Privacidade</a>
        </p>
      </div>
    </div>

    <!-- Rodapé -->
    <footer class="dk-footer">© {{ new Date().getFullYear() }} VSLBooster · Todos os direitos reservados</footer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm } from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import PassWordService from '@/services/RedefirSenha'
import Swal from 'sweetalert2'

export default {
  components: {
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  metaInfo: {
    title: 'Login | VSLBooster',
    titleTemplate: '%s',
    meta: [
      { name: 'description', content: 'Acesse sua conta VSLBooster. Gerencie seus vídeos, analytics, conversões e otimize suas Video Sales Letters.' },
      { property: 'og:title', content: 'Login | VSLBooster' },
      { property: 'og:description', content: 'Acesse sua conta VSLBooster e gerencie seus vídeos e conversões.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'VSLBooster' },
    ],
    link: [
      { rel: 'canonical', href: 'https://app.vslbooster.com/login' },
    ],
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      status: '',
      password: '',
      userEmail: '',
      required,
      email,
      usuario: [],
      nome: '',
      sobrenome: '',
      lembrar: false,
      isLoading: false,
      loadingStep: 0,
      loadingSteps: [
        { msg: 'Verificando suas credenciais...', pct: 20 },
        { msg: 'Autenticando com segurança...', pct: 45 },
        { msg: 'Carregando seus dados...', pct: 70 },
        { msg: 'Preparando seu painel...', pct: 90 },
        { msg: 'Tudo pronto! Redirecionando...', pct: 100 },
      ],
      loadingTimers: [],
      errorMsg: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    startLoading() {
      this.isLoading = true
      this.loadingStep = 0
      this.loadingTimers.forEach(t => clearTimeout(t))
      this.loadingTimers = this.loadingSteps.map((_, i) =>
        setTimeout(() => { this.loadingStep = i }, i * 600)
      )
    },
    stopLoading() {
      this.isLoading = false
      this.loadingTimers.forEach(t => clearTimeout(t))
      this.loadingStep = 0
    },

    getUsuarioEmail() {
      this.errorMsg = ''
      this.startLoading()
      const options = {
        method: 'POST',
        url: `${this.VUE_APP_HOST_API_BACKEND}/usuario_email`,
        headers: { 'Content-Type': 'application/json' },
        data: { user_email: `${this.userEmail}` },
      }
      axios.request(options)
        .then(response => {
          const usuario = response.data && response.data[0]
          if (!usuario) {
            this.stopLoading()
            this.errorMsg = 'E-mail não encontrado. Verifique e tente novamente.'
            return
          }
          if (!usuario.user_primeiro_acesso) {
            this.loginInput()
          } else {
            // Guarda os dados do usuário em sessionStorage como backup seguro
            sessionStorage.setItem('rst_user_id', usuario.id || '')
            sessionStorage.setItem('rst_user_email', usuario.user_email || this.userEmail)
            this.stopLoading()
            const email = usuario.user_email || this.userEmail
            this.$router.push(`/RedefinirSenha/${encodeURIComponent(email)}`)
          }
        }).catch(() => {
          this.stopLoading()
          this.errorMsg = 'E-mail não encontrado. Verifique e tente novamente.'
        })
    },

    async loginInput() {
      await this.$refs.loginValidation.validate().then(success => {
        if (success) {
          useJwt.login({
            user_email: this.userEmail,
            user_password: this.password,
          }).then(response => {
            const { userData } = response.data
            if (userData.user_ativo === 0) {
              this.stopLoading()
              Swal.fire(
                'Usuário bloqueado!',
                `<div style="text-align:left"><p>Entre em contato com a equipe VSL Booster</p><p>E-mail: <strong>financeiro@vslbooster.com</strong></p></div>`,
                'error',
              )
              return
            }
            localStorage.setItem('lgn_admin', JSON.stringify(userData.user_role))
            useJwt.setToken(response.data.accessToken)
            useJwt.setRefreshToken(response.data.refreshToken)
            localStorage.setItem('userData', JSON.stringify(userData))
            this.$ability.update(userData.ability)
            this.$router.replace(getHomeRouteForLoggedInUser(userData.user_role))
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Bem-vindo ${userData.user_name || userData.user_sobrenome}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                  },
                })
              })
          }).catch(() => {
            this.stopLoading()
            this.errorMsg = 'E-mail ou senha incorretos. Tente novamente.'
          })
        }
      })
    },

    async Password() {
      const options = {
        method: 'POST',
        url: `${this.VUE_APP_HOST_API_BACKEND}/usuario_email`,
        headers: { 'Content-Type': 'application/json' },
        data: { user_email: `${this.userEmail}` },
      }
      axios.request(options)
        .then(response => {
          if (typeof response.data[0] !== 'undefined') {
            PassWordService.ChangePassword(this.userEmail)
              .then(response => {
                if (response.data.auth === true) {
                  this.$router.push({ name: 'verificarEmail' })
                }
              }).catch(error => { console.log('error', error) })
          } else {
            this.$message({ type: 'error', message: 'Email não encontrado' })
          }
        }).catch(error => { console.error(error) })
    },

    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.getUsuarioEmail()
        }
      })
    },
  },
}
</script>

<style lang="scss">
/* Reset do tema Vuexy para esta página */
.dk-login-page {
  * { box-sizing: border-box; margin: 0; padding: 0; }

  .validation-observer { display: block; }
  .validation-provider { display: block; }
}
</style>

<style scoped lang="scss">
/* ── Paleta DK ─────────────────────────────── */
$navy: #0D3349;
$navy2: #0a2840;
$navy3: #061d30;
$orange: #E86A10;
$gold: #F5B935;

/* ── Página ───────────────────────────────── */
.dk-login-page {
  min-height: 100vh;
  font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;
  background: linear-gradient(150deg, $navy 0%, $navy2 55%, $navy3 100%);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* ── Glows ────────────────────────────────── */
.dk-glow-tr {
  position: absolute; top: -200px; right: -150px;
  width: 600px; height: 600px; pointer-events: none;
  background: radial-gradient(circle, rgba(232,106,16,0.14) 0%, transparent 70%);
}
.dk-glow-bl {
  position: absolute; bottom: -150px; left: -100px;
  width: 500px; height: 500px; pointer-events: none;
  background: radial-gradient(circle, rgba(245,185,53,0.08) 0%, transparent 70%);
}
.dk-glow-center {
  position: absolute; top: 20%; left: 50%; transform: translateX(-50%);
  width: 600px; height: 600px; pointer-events: none;
  background: radial-gradient(circle, rgba(232,106,16,0.13) 0%, transparent 65%);
}

/* ── Loading Overlay ──────────────────────── */
.dk-loading-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: linear-gradient(150deg, $navy 0%, $navy2 55%, $navy3 100%);
  display: flex; align-items: center; justify-content: center;
}
.dk-fade-enter-active, .dk-fade-leave-active { transition: opacity 0.35s ease; }
.dk-fade-enter, .dk-fade-leave-to { opacity: 0; }

.dk-loading-content {
  display: flex; flex-direction: column; align-items: center; position: relative; z-index: 1;
}
.dk-logo-pulse {
  width: 72px; height: 72px; border-radius: 20px;
  background: linear-gradient(135deg, $orange, $gold);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 40px rgba(232,106,16,0.45);
  animation: dkPulse 1.8s ease-in-out infinite;
  margin-bottom: 16px;
}
.dk-play-icon { color: #fff; font-size: 30px; font-weight: 900; margin-left: 4px; }
.dk-brand-name { color: #fff; font-weight: 900; font-size: 1.5rem; letter-spacing: -0.5px; margin-bottom: 28px; }
.dk-loading-msg { color: rgba(255,255,255,0.65); font-size: 0.95rem; margin-bottom: 24px; min-height: 26px; text-align: center; }
.dk-progress-wrap { width: 280px; }
.dk-progress-track { height: 4px; background: rgba(255,255,255,0.08); border-radius: 4px; overflow: hidden; }
.dk-progress-bar { height: 100%; border-radius: 4px; background: linear-gradient(90deg, $orange, $gold); transition: width 0.5s cubic-bezier(0.4,0,0.2,1); box-shadow: 0 0 12px rgba(245,185,53,0.6); }
.dk-progress-row { display: flex; justify-content: space-between; margin-top: 8px; }
.dk-progress-label { color: rgba(255,255,255,0.25); font-size: 0.7rem; }
.dk-progress-pct { color: $gold; font-size: 0.7rem; font-weight: 700; }
.dk-dots { display: flex; gap: 8px; margin-top: 32px; }
.dk-dot { height: 7px; width: 7px; border-radius: 4px; background: rgba(255,255,255,0.1); transition: all 0.4s ease; }
.dk-dot.active { width: 22px; background: linear-gradient(90deg, $orange, $gold); }
.dk-dot.done { background: linear-gradient(90deg, $orange, $gold); }

@keyframes dkPulse {
  0%, 100% { transform: scale(1); box-shadow: 0 0 40px rgba(232,106,16,0.45); }
  50% { transform: scale(1.06); box-shadow: 0 0 60px rgba(232,106,16,0.7); }
}

/* ── Navbar ───────────────────────────────── */
.dk-nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 40px; height: 66px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  position: relative; z-index: 10;
}
.dk-logo { display: flex; align-items: center; gap: 10px; }
.dk-logo-icon {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, $orange, $gold);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 900; color: #fff;
}
.dk-logo-text { color: #fff; font-weight: 900; font-size: 18px; letter-spacing: -0.5px; }
.dk-gold { color: $gold; }
.dk-nav-right { display: flex; gap: 8px; align-items: center; }
.dk-nav-hint { color: rgba(255,255,255,0.5); font-size: 0.85rem; font-weight: 500; }
.dk-nav-cta-link { color: $gold; font-size: 0.85rem; font-weight: 700; text-decoration: none; transition: opacity 0.2s; }
.dk-nav-cta-link:hover { opacity: 0.8; text-decoration: none; }
.dk-btn-outline {
  background: linear-gradient(135deg, $orange, $gold);
  color: #fff; font-weight: 700; font-size: 0.82rem;
  padding: 9px 20px; border-radius: 9px; text-decoration: none;
  box-shadow: 0 4px 14px rgba(232,106,16,0.4);
}

/* ── Conteúdo ─────────────────────────────── */
.dk-content {
  flex: 1; display: flex; align-items: center; justify-content: center;
  padding: 48px 40px; gap: 64px; position: relative; z-index: 1;
}

/* ── Esquerdo ─────────────────────────────── */
.dk-left { max-width: 420px; display: flex; flex-direction: column; gap: 28px; }
.dk-badge {
  display: inline-block; width: fit-content;
  background: rgba(232,106,16,0.12); border: 1px solid rgba(232,106,16,0.28);
  color: $orange; font-weight: 700; font-size: 0.7rem;
  letter-spacing: 1.5px; text-transform: uppercase;
  padding: 5px 14px; border-radius: 20px;
}
.dk-headline {
  color: #fff; font-weight: 900;
  font-size: clamp(1.9rem, 3vw, 2.7rem);
  line-height: 1.08; letter-spacing: -1.5px;
}
.dk-subtext { color: rgba(255,255,255,0.5); font-size: 0.93rem; line-height: 1.75; }

.dk-stats-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.dk-stat-card {
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; padding: 18px 16px;
}
.dk-stat-val { font-weight: 900; font-size: 1.5rem; letter-spacing: -0.5px; }
.dk-stat-label { color: rgba(255,255,255,0.35); font-size: 0.72rem; margin-top: 4px; }

.dk-social-proof {
  display: flex; align-items: center; gap: 14px;
  padding-top: 16px; border-top: 1px solid rgba(255,255,255,0.07);
}
.dk-avatars { display: flex; }
.dk-avatar {
  width: 32px; height: 32px; border-radius: 50%;
  border: 2px solid #0a2840;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-weight: 800; font-size: 0.72rem;
  margin-left: -10px;
  &:first-child { margin-left: 0; }
}
.dk-proof-text { color: rgba(255,255,255,0.35); font-size: 0.78rem; }

/* ── Card formulário ──────────────────────── */
.dk-card {
  width: 100%; max-width: 440px;
  background: rgba(255,255,255,0.04);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 24px;
  padding: 44px 40px;
  box-shadow: 0 40px 100px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.08);
}
.dk-card-header { margin-bottom: 28px; }
.dk-card-title { color: #fff; font-weight: 900; font-size: 1.55rem; letter-spacing: -0.5px; margin-bottom: 8px; }
.dk-card-sub { color: rgba(255,255,255,0.4); font-size: 0.86rem; }
.dk-link-gold { color: $gold; font-weight: 700; text-decoration: none; }

/* Erro */
.dk-error-box {
  background: rgba(220,53,69,0.1); border: 1px solid rgba(220,53,69,0.3);
  border-radius: 10px; padding: 12px 16px; margin-bottom: 18px;
  color: #ff8a9a; font-size: 0.82rem; line-height: 1.5;
}

/* Formulário */
.dk-form { display: flex; flex-direction: column; gap: 0; }
.dk-field-wrap { margin-bottom: 18px; }
.dk-label { display: block; color: rgba(255,255,255,0.55); font-size: 0.78rem; font-weight: 600; margin-bottom: 8px; letter-spacing: 0.3px; }
.dk-label-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.dk-link-forgot { color: $gold; font-size: 0.76rem; font-weight: 600; text-decoration: none; }

.dk-input-wrap { position: relative; }
.dk-field-icon {
  position: absolute; left: 16px; top: 50%; transform: translateY(-50%);
  width: 16px; height: 16px; color: rgba(255,255,255,0.25);
  pointer-events: none; transition: color 0.2s;
}
.dk-input {
  width: 100%;
  padding: 14px 16px 14px 44px;
  background: rgba(255,255,255,0.05);
  border: 1.5px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  color: #fff; font-size: 0.9rem;
  font-family: 'Inter', sans-serif;
  outline: none; transition: border 0.2s, background 0.2s, box-shadow 0.2s;

  &::placeholder { color: rgba(255,255,255,0.25); }
  &:focus {
    border-color: rgba(232,106,16,0.6);
    background: rgba(255,255,255,0.07);
    box-shadow: 0 0 0 3px rgba(232,106,16,0.12);
  }
  &.dk-input-filled { border-color: rgba(232,106,16,0.4); }
  &.dk-input-error { border-color: rgba(220,53,69,0.5); }
}
.dk-field-error { color: rgba(255,138,154,0.9); font-size: 0.75rem; margin-top: 5px; display: block; }

.dk-eye-btn {
  position: absolute; right: 14px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  color: rgba(255,255,255,0.3); padding: 4px; display: flex; align-items: center;
}

/* Lembrar */
.dk-remember-row { display: flex; align-items: center; gap: 10px; margin-bottom: 24px; cursor: pointer; }
.dk-checkbox {
  width: 18px; height: 18px; border-radius: 5px; flex-shrink: 0;
  border: 2px solid rgba(255,255,255,0.2);
  background: transparent;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.2s;
  &.checked { border-color: $orange; background: $orange; span { color: #fff; font-size: 11px; font-weight: 900; } }
}
.dk-remember-label { font-size: 0.82rem; color: rgba(255,255,255,0.4); }

/* Botão principal */
.dk-btn-primary {
  width: 100%; padding: 16px;
  background: linear-gradient(135deg, $orange, $gold);
  border: none; border-radius: 12px; cursor: pointer;
  color: #fff; font-weight: 800; font-size: 1rem;
  font-family: 'Inter', sans-serif;
  box-shadow: 0 8px 28px rgba(232,106,16,0.45);
  letter-spacing: 0.2px; transition: opacity 0.2s, transform 0.15s;
  &:hover:not(:disabled) { opacity: 0.92; transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}

/* Divisor */
.dk-divider { display: flex; align-items: center; gap: 12px; margin: 22px 0; }
.dk-divider-line { flex: 1; height: 1px; background: rgba(255,255,255,0.08); }
.dk-divider-text { color: rgba(255,255,255,0.2); font-size: 0.72rem; white-space: nowrap; }

/* Botão Google */
.dk-btn-google {
  width: 100%; padding: 13px;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 12px;
  font-family: 'Inter', sans-serif; font-weight: 600; font-size: 0.87rem;
  color: rgba(255,255,255,0.65); transition: background 0.2s, border 0.2s;
  &:hover { background: rgba(255,255,255,0.09); border-color: rgba(255,255,255,0.18); }
}

/* Termos */
.dk-terms { text-align: center; color: rgba(255,255,255,0.18); font-size: 0.68rem; margin-top: 22px; line-height: 1.6; }
.dk-terms-link { color: rgba(255,255,255,0.3); text-decoration: underline; }

/* Rodapé */
.dk-footer {
  padding: 18px 40px; border-top: 1px solid rgba(255,255,255,0.05);
  text-align: center; color: rgba(255,255,255,0.2); font-size: 0.7rem;
  position: relative; z-index: 1;
}

/* ══ RESPONSIVO ══════════════════════════════════════════════════ */

/* ── Tablet: 641px – 900px ──────────────────────────────────── */
@media (max-width: 900px) {
  .dk-content {
    flex-direction: column;
    align-items: center;
    padding: 36px 28px;
    gap: 36px;
  }
  .dk-left {
    max-width: 560px;
    width: 100%;
    order: 2;
  }
  .dk-card {
    max-width: 500px;
    width: 100%;
    order: 1;
  }
  .dk-nav { padding: 0 24px; }
  .dk-footer { padding: 14px 24px; }
}

/* ── Mobile: ≤ 640px ─────────────────────────────────────────── */
@media (max-width: 640px) {
  .dk-nav {
    padding: 0 16px;
    height: 56px;
  }

  .dk-content {
    padding: 20px 16px 32px;
    gap: 24px;
  }

  .dk-left {
    max-width: 100%;
    gap: 18px;
  }

  .dk-headline {
    font-size: 1.55rem;
    letter-spacing: -0.8px;
  }

  .dk-subtext {
    font-size: 0.86rem;
  }

  .dk-stat-card {
    padding: 14px 12px;
  }

  .dk-stat-val {
    font-size: 1.25rem;
  }

  .dk-social-proof {
    display: none;
  }

  .dk-card {
    max-width: 100%;
    padding: 28px 20px 24px;
    border-radius: 18px;
  }

  .dk-footer {
    padding: 14px 16px;
  }

  .dk-btn-outline {
    font-size: 0.75rem;
    padding: 8px 14px;
  }
}
</style>
